import { Panel, Icon } from "rsuite";
import _ from "lodash";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import { createUseStyles } from "react-jss";
import airplane from "../icons/packageIcons/airplane.svg";
import car from "../icons/packageIcons/car.svg";
import hotel from "../icons/packageIcons/hotel.svg";
import infoIcon from "../icons/packageIcons/infoIcon.svg";
import { StyleTypeContext } from "../../umbilical_tools";
import jssVariables from "../../jss_setup";
import RatingPanel from "../common/RatingPanel";

const servicePanelStyles = createUseStyles({
  servicePanel: (props) => ({
    display: "grid",
    gridTemplateColumns: "repeat(3, max-content)",
    background: jssVariables.colors.base_colorType2,
    color: "white",
    padding: `calc(${jssVariables.normal_gap} * 1.5) `,
    gap: `calc(${jssVariables.normal_gap} * 1.5)`,
    width: "100",
    alignItems: "center",
    justifyContent: "space-between",
    ..._.get(props, "customStyles.servicePanel", {}),
  }),
  infoBtn: (props) => ({
    ..._.get(props, "customStyles.infoBtn", {}),
  }),
  data: (props) => ({
    display: "grid",
    gridTemplateRows: "repeat(3, auto)",
    gap: 0,
    color: "white",
    ..._.get(props, "customStyles.data", {}),
  }),
  header: (props) => ({
    fontSize: "large",
    fontWeight: "bold",
    textTransform: "uppercase",
    ..._.get(props, "customStyles.header", {}),
  }),
  txt: (props) => ({
    fontSize: "medium",
    ..._.get(props, "customStyles.txt", {}),
  }),
  time: (props) => ({
    color: "#62BFC0",
    fontWeight: "bold",
    fontSize: "large",

    ..._.get(props, "customStyles.time", {}),
  }),
  img: (props) => ({
    justifySelf: "end",
    ..._.get(props, "customStyles.img", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    servicePanel: (props) => ({
      ..._.get(props, "customStyles.servicePanel.smallscreen", {}),
    }),
  },
});
export const ServicePanel = ({ icon, title, event, customStyles }) => {
  const classes = servicePanelStyles({
    customStyles,
  });

  function getIcon() {
    switch (icon) {
      case "plane":
        return airplane;
      case "car":
        return car;
      case "hotel":
        return hotel;

      default:
        break;
    }
  }
  return (
    <div className={classes.servicePanel}>
      <span className={classes.infoBtn}>
        <img className={classes.img} alt="" src={infoIcon} />
      </span>
      <span className={classes.data}>
        <span className={classes.header}>{event}:</span>
        <span className={classes.txt}>{title}</span>
      </span>

      <img className={classes.img} alt="" src={getIcon()} />
    </div>
  );
};
ServicePanel.defaultProps = {
  icon: "",
  title: "",
  event: "",
  time: "",
  customStyles: {},
};
ServicePanel.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  event: PropTypes.string.isRequired,
  time: PropTypes.string.isRequired,
  customStyles: PropTypes.object,
};

const serviceHeaderStyles = createUseStyles({
  header: {
    display: "grid",
    gridTemplateColumns: "auto 1fr",
    alignItems: "center",
    gridGap: `calc(${jssVariables.normal_gap} / 2)`,
    whiteSpace: "pre-wrap",
  },
});

export const ServiceHeader = (props) => {
  const { icon, event, title, idx } = props;

  const classes = serviceHeaderStyles();

  return (
    <h5 className={classes.header}>
      {idx ? `${idx}.` : ""}
      <Icon icon={icon} size="2x" />
      <span>{event ? `${_.startCase(event)}: ${title}` : title}</span>
    </h5>
  );
};
ServiceHeader.defaultProps = {
  icon: "",
  event: "",
  idx: 0,
  title: "",
};
ServiceHeader.propTypes = {
  icon: PropTypes.string.isRequired,
  event: PropTypes.string.isRequired,
  idx: PropTypes.number,
  title: PropTypes.string.isRequired,
};

export const desktopSrvPanelHeight = "25vh";

export const srvPanelStyles = {
  "display": "grid",
  "height": "30vh",
  "position": "relative",
  "gridTemplateRows": "auto 1fr",
  "& > .rs-panel-heading": {
    padding: jssVariables.normal_gap,
    borderBottom: `2px solid ${jssVariables.colors.base_color}`,
  },
  "& .rs-panel-body": {
    position: "relative",
    display: "grid",
  },
};

export const srvImgStyles = {
  position: "absolute",
  height: "100%",
  width: "100%",
  objectFit: "cover",
  left: 0,
  top: 0,
};

const accPanelStyles = createUseStyles({
  panel: { ...srvPanelStyles },
  img: { ...srvImgStyles },
  content: {
    display: "grid",
    alignItems: "end",
    zIndex: 0,
  },
  rate: {
    alignSelf: "start",
    border: `2px solid ${jssVariables.colors.base_color}`,
    borderRadius: jssVariables.normal_gap,
    padding: `calc(${jssVariables.normal_gap} / 4) calc(${jssVariables.normal_gap} / 2)`,
    background: "rgba(255, 255, 255, 0.6)",
    justifySelf: "start",
  },
  [`@media ${jssVariables.media.smallscreen}`]: {
    panel: {
      height: desktopSrvPanelHeight,
    },
  },
});

export const AccommodationPanel = (props) => {
  const { dayIdx, item, eventType, customStyles } = props;
  const { type } = useContext(StyleTypeContext);

  const classes = accPanelStyles();

  return _.get(item, "accommodations", [])
    .filter((acc) => acc.events[dayIdx] === eventType)
    .map((acc, idx) => {
      const event = acc.events[dayIdx];

      return type !== "type2" ? (
        <Panel
          className={classes.panel}
          key={idx}
          header={
            <ServiceHeader
              icon="h-square"
              title={acc.metadata.name}
              event={_.startCase(event)}
            />
          }
          shaded>
          <img
            className={classes.img}
            alt=""
            src={_.get(acc, "metadata.images.0.url", "")}
          />
          <div className={classes.content}>
            <div className={classes.rate}>
              <RatingPanel rating={_.get(acc, "metadata.rating", 1)} />
            </div>
          </div>
        </Panel>
      ) : (
        <ServicePanel
          icon="hotel"
          key={idx}
          title={acc.metadata.name}
          event={_.startCase(event)}
          time={
            event === "check_in"
              ? _.get(item, "destinations[0].checkIn", "")
              : _.get(item, "destinations[0].checkOut", "")
          }
          customStyles={customStyles}
        />
      );
    });
};

AccommodationPanel.propTypes = {
  dayIdx: PropTypes.number.isRequired,
  item: PropTypes.object.isRequired,
  eventType: PropTypes.string.isRequired,
  customStyles: PropTypes.object.isRequired,
};
